"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _attributionBlock = _interopRequireDefault(require("@site/pattern-library-core/attribution-block"));
const ImageContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "ImageContainer",
  class: "pl-i160p8nc",
  vars: {
    "i160p8nc-0": [({
      invert
    }) => invert ? `${_intents.default.ux.boxHighContrast.foregroundColor}` : `${_intents.default.ux.boxHighContrast.backgroundColor}`]
  }
});
const StyledParagraph = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "StyledParagraph",
  class: "pl-s1d32dim",
  vars: {
    "s1d32dim-1": [({
      invert
    }) => invert ? `${_intents.default.ux.boxHighContrast.foregroundColor}` : `${_intents.default.ux.boxHighContrast.backgroundColor}`],
    "s1d32dim-4": [({
      cardSize
    }) => cardSize === 'lg' ? 'center' : 'flex-start']
  }
});

// TODO: CMS-28892: remove this backwards compatibility parser
// when all ImageCards are no longer coming from Sitecore or the
// CardType is updated to have a single attribution field
function parseAttribution(attribution) {
  if (!attribution) return null;
  if (typeof attribution === 'string') return attribution;
  return `${attribution.lineOne}\n${attribution.lineTwo}`;
}

/**
 * ImageCard Component.
 *
 * @param {Object} props React props
 * @param {String} props.text Image Content
 * @param {Object} props.portrait Mobile Image
 * @param {Object} props.landscape Desktop Image
 * @param {String} props.partial Theme partial
 * @param {String} props.cardSize Image Card Size
 * @param {Object} props.attribution Attribution
 * @param {String} props.attributionPosition Position of Attribution
 * @param {String} props.align LTR - RTL control
 * @returns {React.ReactElement} ImageCard Component
 * @public
 */

function RTBImageCard({
  text,
  portrait,
  landscape,
  attribution,
  attributionPosition = 'bottom',
  invert = false,
  cardSize = 'sm',
  align = 'left',
  partial
}) {
  return /*#__PURE__*/_react.default.createElement(ImageContainer, {
    role: "img",
    className: "rtb-card image-card",
    portrait: portrait?.url,
    landscape: landscape?.url,
    "aria-label": text,
    "data-align": align,
    "data-cy": "image-card",
    "data-partial": partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(StyledParagraph, {
    asType: "title",
    text: text,
    className: "h5",
    invert: invert,
    cardSize: cardSize
  }), attribution ? /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    isFigcaption: false,
    attribution: parseAttribution(attribution),
    attributionPosition: attributionPosition,
    onlyBoldLineOne: true
  }) : null);
}
RTBImageCard.propTypes = {
  text: _propTypes.default.string,
  portrait: _propTypes.default.object,
  landscape: _propTypes.default.object,
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  attribution: _propTypes.default.string,
  cardSize: _propTypes.default.oneOf(['sm', 'lg']),
  backgroundColor: _propTypes.default.string,
  attributionPosition: _propTypes.default.string,
  align: _propTypes.default.oneOf(['left', 'right'])
};
var _default = exports.default = RTBImageCard;